import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  InputAdornment,
  CircularProgress,
} from "@mui/material";

import { apiRequest } from "../../services/api";
import { encryptData } from "../Common/encryptionUtils";
import "./VerifyEmail.css";
import { faL } from "@fortawesome/free-solid-svg-icons";
import CryptoJS from "crypto-js";
const secretKey = "BusinessTimeWebKiosk";

const VerifyEmail = ({
  open,
  handlePopUpClose,
  userData = {}, // Default to an empty object
  navigate,
  type,
  customerAccountData = {}, // Default to an empty object
  setLoading,
  countryPhoneCodeData = "",
}) => {
  console.log("customerAccountData--->");
  const [phone, setPhone] = useState("");
  const [countryPhoneCode, setCountryPhoneCode] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const handleClose = () => {
    setPhone(""); // Clear phone number input
    setOtp(""); // Clear OTP input
    setMessage(""); // Clear error/success messages
    setErrorMessage("");
    setOtpSent(false); // Reset OTP sent state
    handlePopUpClose();
  };

  const sendOtp = async (values) => {
    setIsSendingOtp(true);
    // Save email to localStorage
    const email = customerAccountData?.email;
    const payload = {
      email,
    };
    console.log("payload-->", payload);

    const authToken = localStorage.getItem("authToken");

    const headers = {
      Authorization: `Bearer ${authToken}`,
    };

    try {
      const response = await apiRequest(
        "web_api/admin/send_otp_to_email",
        "POST",
        payload,
        headers
      );
      console.log("responseAPIs--->", response);
      if (response?.data?.status === 200) {
        setOtpSent(true);
        setMessage("OTP sent successfully!");
        setIsSendingOtp(false);
        // Handle successful login (e.g., redirect, update state)
      } else {
        toast.error(response.data?.message);
      }
    } catch (error) {
      toast.error("Login failed. Please try again.");
    } finally {
      setLoading(false);
      setIsSendingOtp(false);
    }
  };

  const verifyOtp = async () => {
    if (!otp || otp.length !== 6 || !/^\d{6}$/.test(otp)) {
      setErrorMessage("Enter a valid 6-digit OTP.");
      return;
    }
    setIsVerifyingOtp(true);
    const payload = {
      email: customerAccountData?.email,
      otp: otp,
    };

    const authToken = localStorage.getItem("authToken");

    const headers = {
      Authorization: `Bearer ${authToken}`,
    };
    // OTP Verification API
    try {
      const response = await apiRequest(
        "web_api/admin/verify_email_otp",
        "POST",
        payload,
        headers
      );
      if (response.data?.status == 200) {
        const encrypted = CryptoJS.AES.encrypt(
          "verified:true",
          secretKey
        ).toString();
        localStorage.setItem("verificationToken", encrypted);
        navigate("/users");
        setTimeout(() => {
          toast.success("OTP verifed Successfully.");
          // setSubmitting(false);
        }, 100);
      } else {
        setErrorMessage("Invalid OTP. Try again.");
        setIsVerifyingOtp(false);
      }
    } catch (error) {
      setErrorMessage("Invalid OTP. Try again.");
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  // Send OTP
  //   const sendOtp = async () => {
  //     if (!phone) {
  //       setErrorMessage("Phone number cannot be empty.");
  //       return false;
  //     }

  //     if (!phone || phone.length !== 10) {
  //       setErrorMessage("Enter a valid phone number");
  //       return;
  //     } else {
  //       setErrorMessage("");
  //     }

  //     const validatePhoneNumber = (phone) => {
  //       const indianRegex = /^[6-9]\d{9}$/; // India: 10-digit number starting with 6-9
  //       const defaultRegex = /^[2-9]\d{9}$/; // Other countries: 10-digit number starting with 2-9

  //       return countryPhoneCode === "+91"
  //         ? indianRegex.test(phone)
  //         : defaultRegex.test(phone);
  //     };

  //     if (!validatePhoneNumber(phone)) {
  //       setErrorMessage("Enter a valid phone number.");
  //       return;
  //     }

  //     const checkMobileNumber = async () => {
  //       try {
  //         const authToken = localStorage.getItem("authToken");
  //         const headers = {
  //           Authorization: `Bearer ${authToken}`,
  //         };
  //         const payload = {
  //           phone_number: encryptData(phone?.toString()),
  //         };
  //         const response = await apiRequest(
  //           `web_api/admin/checkPhoneNumber`,
  //           "POST",
  //           payload,
  //           headers
  //         );

  //         if (response.data?.status_code == 200) {
  //           // showToast(response.data?.message);
  //           setErrorMessage(
  //             "This phone no is already taken. Please try a different one."
  //           );
  //         } else {
  //           // setMessage("");
  //           try {
  //             setIsSendingOtp(true);
  //             setupRecaptcha();
  //             const appVerifier = window.recaptchaVerifier;
  //             const confirmation = await signInWithPhoneNumber(
  //               auth,
  //               countryPhoneCode + phone,
  //               appVerifier
  //             );

  //             setConfirmationResult(confirmation);
  //             setOtpSent(true);
  //             setMessage("OTP sent successfully!");
  //             setIsSendingOtp(false);
  //           } catch (error) {
  //             console.error("OTP Send Error:", error);
  //             setErrorMessage(error.message || "Failed to send OTP. Try again.");
  //           }
  //         }
  //       } catch (error) {
  //         console.log("error", error);
  //       } finally {
  //       }
  //     };
  //     if (type === "UserPhoneVerify") {
  //       checkMobileNumber();
  //     } else {
  //       try {
  //         setIsSendingOtp(true);
  //         setupRecaptcha();
  //         const appVerifier = window.recaptchaVerifier;
  //         const confirmation = await signInWithPhoneNumber(
  //           auth,
  //           countryPhoneCode + phone,
  //           appVerifier
  //         );

  //         setConfirmationResult(confirmation);
  //         setOtpSent(true);
  //         setMessage("OTP sent successfully!");
  //         setIsSendingOtp(false);
  //       } catch (error) {
  //         console.error("OTP Send Error:", error);
  //         setErrorMessage(error.message || "Failed to send OTP. Try again.");
  //       }
  //     }
  //   };

  // Verify OTP
  //   const verifyOtp = async () => {
  //     if (!otp || otp.length !== 6 || !/^\d{6}$/.test(otp)) {
  //       setErrorMessage("Enter a valid 6-digit OTP.");
  //       return;
  //     }

  //     try {
  //       setIsVerifyingOtp(true);
  //       await confirmationResult.confirm(otp);
  //       // setMessage("OTP verified successfully!");
  //       // Call API to update phone number
  //       if (type === "UserPhoneVerify") {
  //         await updatePhoneNumberAPI(phone);
  //       } else if (type === "CustomerAccountPhoneVerify") {
  //         await verifyPhoneNumberAPI(phone);
  //       }
  //       setIsVerifyingOtp(false);
  //       handleClose();
  //       setErrorMessage("");
  //     } catch (error) {
  //       console.error("OTP Verification Error:", error);
  //       setErrorMessage("Invalid OTP. Try again.");
  //       setIsVerifyingOtp(false);
  //     }
  //   };

  const updatePhoneNumberAPI = async (phoneNo) => {
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const payload = {
        user_id: encryptData(userData?.user_id?.toString()),
        new_phone_number: encryptData(phoneNo?.toString()),
      };
      const response = await apiRequest(
        `web_api/admin/updateUsersPhoneNumber`,
        "PUT",
        payload,
        headers
      );

      if (response?.data?.status_code == 200) {
        navigate("/users");
        setTimeout(() => {
          toast.success(response?.data?.message);
          // setSubmitting(false);
        }, 100);
      } else {
        throw new Error(
          response?.data?.message || "Failed to update phone number."
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to update phone number.");
    }
  };

  const verifyPhoneNumberAPI = async (phoneNo) => {
    try {
      setLoading(true);
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const payload = {
        customer_account_users_id: encryptData(
          customerAccountData?.customer_account_users_id?.toString()
        ),
      };
      const response = await apiRequest(
        `web_api/admin/verifyCustomerAccountPhoneNumber`,
        "PUT",
        payload,
        headers
      );

      if (response?.data?.status_code == 200) {
        setLoading(false);

        // window.location.href = "/dashboard";
        setTimeout(() => {
          toast.success(response?.data?.message);
          // setSubmitting(false);
        }, 500);
      } else {
        setLoading(false);
        throw new Error(
          response?.data?.message || "Failed to verify phone number."
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to verify phone number.");
    }
  };

  useEffect(() => {
    if (type === "CustomerAccountPhoneVerify") {
      setPhone(customerAccountData?.phone);
      setCountryPhoneCode(customerAccountData?.phone_no_country_code);
    } else if (type === "UserPhoneVerify") {
      setCountryPhoneCode(countryPhoneCodeData);
    }
  }, [open]);

  const otpInputRef = useRef(null);

  useEffect(() => {
    if (otpSent && otpInputRef.current) {
      otpInputRef.current.focus();
    }
  }, [otpSent]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Verify Email</DialogTitle>
      <DialogContent>
        {!otpSent ? (
          <>
            <TextField
              fullWidth
              label={
                <span>
                  Email <span style={{ color: "red" }}>*</span>
                </span>
              }
              placeholder=""
              variant="outlined"
              autoFocus
              value={customerAccountData?.email}
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d{0,10}$/.test(input)) {
                  setPhone(input); // Allow only numbers up to 10 digits
                  setErrorMessage("");
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  sendOtp(); // call sendOtp on Enter key press
                }
              }}
              margin="dense"
              inputProps={{
                readOnly: true,
                className: "viewOptionField",
              }}
            />
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={sendOtp}
              sx={{ mt: 2 }}
            >
              {isSendingOtp ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Send OTP"
              )}
              {/* Send OTP */}
            </Button>
            <div id="recaptcha-container"></div>
          </>
        ) : (
          <>
            {/* <Typography variant="h6" color="primary" sx={{ mt: 2 }}>
              OTP sent to {phone}
            </Typography> */}
            <TextField
              fullWidth
              label={
                <span>
                  Enter OTP <span style={{ color: "red" }}>*</span>
                </span>
              }
              variant="outlined"
              value={otp}
              autoFocus
              inputRef={otpInputRef}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,6}$/.test(value)) {
                  // Allow only up to 6 digits
                  setOtp(value);
                  setErrorMessage("");
                  setMessage("");
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  verifyOtp(); // call sendOtp on Enter key press
                }
              }}
              margin="dense"
              type="text" // Use text to disable increment/decrement arrows
              inputProps={{
                maxLength: 6, // Ensure max input length is 6
                inputMode: "numeric", // Mobile keyboards show number pad
                pattern: "[0-9]*", // Restrict to numbers
              }}
            />

            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={verifyOtp}
              sx={{ mt: 2 }}
            >
              {isVerifyingOtp ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Verify OTP"
              )}
            </Button>
            {/* <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={() => setOtpSent(false)}
              sx={{ mt: 2 }}
            >
              Back
            </Button> */}
          </>
        )}
        <Typography
          variant="body2"
          color="success"
          className="successMessageDiv"
          sx={{ mt: 2 }}
        >
          {message}
        </Typography>
        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          {errorMessage}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VerifyEmail;
